import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as actionCreators from '../actions';

class LoginView extends Component {

   constructor(props) {
      super(props);
      const {location, appConfig} = this.props;
      let redirectRoute = '/';
      if (location.search && location.search.includes('next=')) {
         redirectRoute = location.search.split('next=')[1];
      }

      let login = appConfig.defUser.login;
      let pass = appConfig.defUser.pass;
      let savePass = true;

      this.state = {
         email: login,
         emailRequired: '',
         password: pass,
         passwordRequired: '',
         savePass: savePass,
         redirectTo: redirectRoute
      };

      this.login = this.login.bind(this);
      this.handleInputChange = this.handleInputChange.bind(this);
   }

   login(e) {
      e.preventDefault();
      if (this.state.email && this.state.email !== '' && this.state.password && this.state.password !== '') {
         const {actions} = this.props;
         actions.loginUser(this.state.email, this.state.password, this.state.redirectTo, this.state.savePass);
      } else {
         const reqMsg = 'This is a required field';
         if (this.state.email === '') {
            this.setState({
               emailRequired: reqMsg
            });
         }
         if (this.state.password === '') {
            this.setState({
               passwordRequired: reqMsg
            });
         }
      }
   }

   handleInputChange(event) {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      const name = target.name;

      this.setState({
         [name]: value
      });
   }

   render() {
      const cardStyle = {
         height: 380,
         width: 400,
         textAlign: 'center',
         position: 'absolute',
         left: '50%',
         top: '50%',
         marginLeft: -200,
         marginTop: -240
      };
      const {isAuthenticating} = this.props;
      return (
         <div>
            <Paper style={cardStyle} zDepth={2}>
               <h2 style={{color:'rgb(0, 188, 212)'}}>Aprentis Docs</h2>
               <form role='form'>
                  <div className='form-group'>
                     <TextField
                        name="email"
                        floatingLabelText="Email"
                        value={this.state.email}
                        onChange={this.handleInputChange}
                        errorText={this.state.emailRequired}
                        inputStyle={{textAlign: 'center'}}
                        hintStyle={{textAlign: 'center', width: '100%'}}
                        floatingLabelStyle={{textAlign: 'center', width: '100%', transformOrigin: 'center top 0px'}}
                     />
                  </div>
                  <div className='form-group'>
                     <TextField
                        name="password"
                        floatingLabelText="Password"
                        type="password"
                        value={this.state.password}
                        onChange={this.handleInputChange}
                        errorText={this.state.passwordRequired}
                        inputStyle={{textAlign: 'center'}}
                        hintStyle={{textAlign: 'center', width: '100%'}}
                        floatingLabelStyle={{textAlign: 'center', width: '100%', transformOrigin: 'center top 0px'}}
                     />
                  </div>
                  <div className='form-group'>
                     <div style={{width: 200, margin: "auto", marginTop: 30}}>
                        <Checkbox
                           name="savePass"
                           label="Remember me"
                           labelPosition="right"
                           checked={this.state.savePass}
                           onCheck={this.handleInputChange}
                        />
                     </div>
                  </div>
                  <RaisedButton
                     label="Login"
                     primary={true}
                     disabled={isAuthenticating}
                     onTouchTap={this.login}
                  />
               </form>
            </Paper>
         </div>
      );
   }
}

LoginView.propTypes = {
   actions: PropTypes.object.isRequired,
   location: PropTypes.object,
   isAuthenticating: PropTypes.bool
};

function mapStateToProps(state) {
   return {
      isAuthenticating: state.auth.isAuthenticating,
      appConfig: state.conf
   }
};

function mapDispatchToProps(dispatch) {
   return {
      actions: bindActionCreators(actionCreators, dispatch)
   }
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginView);



// WEBPACK FOOTER //
// ./src/views/LoginView.js